import { isNotNullOrUndefined } from '../../../util/types/Array';
import { useAllDevices } from './useAllDevices';

/**
 * Use redux to get and fetch device
 * @param deviceId usually is the queryParam
 * @param onError callback when call fail
 * @returns
 */
export const useDevices = (deviceIds: string[]) => {
  const { data: deviceStructure, ...rest } = useAllDevices();
  const devices = deviceIds
    .map((deviceId) => deviceStructure?.entities.devices[deviceId])
    .filter(isNotNullOrUndefined);
  return { data: devices, ...rest };
};
